var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "opportunities-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Initiatives")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/deals",
            text: "All opportunities",
            caption:
              "Find the digital engagements that suit your business best",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/deals")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.spotlight.length
      ? _c(
          "div",
          { staticClass: "extended-block center-block" },
          [
            _c("h6", [_vm._v("Opportunity spotlight")]),
            _vm._v(" "),
            _vm._l(_vm.spotlight, function (item) {
              return _c("menu-item", {
                key: item.id,
                attrs: {
                  path: `/deals/platforms/${item.path}`,
                  text: item.title,
                  caption: item.subtitle,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleItemClick(`/deals/platforms/${item.path}`)
                  },
                },
              })
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showMyProposalsLink
      ? _c(
          "div",
          { staticClass: "extended-block user-block" },
          [
            _c("user-menu-item", {
              attrs: {
                path: "/deals/submissions",
                text: "My proposals",
                caption: _vm.proposalCaption,
              },
              on: {
                click: function ($event) {
                  return _vm.handleItemClick("/deals/submissions")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }